export default __webpack_public_path__ + "static/media/roles_openapi.41cb4c37.yaml";